import { render, staticRenderFns } from "./permissions-header.vue?vue&type=template&id=7e3a2a5e&scoped=true&"
var script = {}
import style0 from "./permissions-header.vue?vue&type=style&index=0&id=7e3a2a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3a2a5e",
  null
  
)

export default component.exports